import { useRef, useEffect } from "react";
import {
  Grid,
  Box,
  Typography,
  FormControl,
  FormGroup,
  Checkbox,
  FormControlLabel,
  OutlinedInput,
  Button,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import { brandingConstants } from "../../PreviewStyles/constants";
import { handleFontPreview } from "../helpers";
import AddIcon from "@mui/icons-material/Add";

interface IProps {
  product: any;
  previewAgent: boolean;
  branding: any;
  technology: string;
  handleBtnPosition: (category: any) => void;
  ClickedCat: any;
  ClickedCatFbsVal: any;
}

const ThirdPagePreview = ({
  product,
  previewAgent,
  branding,
  ClickedCatFbsVal,
  ClickedCat,
  technology,
}: IProps) => {
  return (
    <Grid
      item
      xs={11}
      mt={previewAgent ? "42px" : "15px"}
      id="cuvo-qr-preview-settings"
    >
      <Grid item xs={12} mb={previewAgent ? "25px" : "15px"}>
        <label
          className="overflow-text-2-line"
          style={{
            margin: "15px 0 10px",
            color: branding?.[brandingConstants.inputLabelColor],
            fontSize: handleFontPreview(
              branding?.[brandingConstants.inputLabelFontSize],
              previewAgent
            ),
            fontStyle: branding?.[brandingConstants.inputLabelFontStyle],
            fontFamily: branding?.[brandingConstants.inputLabelFontFamily],
            fontWeight: branding?.[brandingConstants.inputLabelFontWeight],
          }}
        >
          {`Email ${product?.requireEmail ? "(Required)" : ""}`}
        </label>
        <FormControl className="custom-select custom-textarea" fullWidth>
          {/* <input
            className="feedback-input"
            placeholder="Your email"
            type="text"
            style={{
              color: branding?.[brandingConstants.inputFieldTextColor],
              // fontSize: handleFontPreview(
              //   branding?.[brandingConstants.inputLabelFontSize],
              //   previewAgent
              // ),
              fontSize: previewAgent ? "18px" : "9px",
              backgroundColor: branding?.[brandingConstants.inputFieldBGColor],
              border:
                "4px solid" +
                branding?.[brandingConstants?.inputFieldBorderColor],
              borderRadius:
                technology === "html5Tv"
                  ? branding?.[brandingConstants.inputFieldBorderRadius]
                  : "0px",
              height: previewAgent ? "60px" : "30px",
              background: "#fff",
              width: previewAgent ? "641px" : "100%",
            }}
          /> */}

          <OutlinedInput
            className="noborder feedback-input"
            sx={{
              color: branding?.[brandingConstants.inputFieldTextColor],
              background: branding?.[brandingConstants.inputFieldBGColor],
              border:
                "4px solid" +
                branding?.[brandingConstants?.inputFieldBorderColor],
              borderRadius:
                technology === "html5Tv"
                  ? branding?.[brandingConstants.inputFieldBorderRadius]
                  : "0px",
              "& input": {
                fontSize: previewAgent ? "14px!important" : "11px!important",
                fontStyle: branding?.[brandingConstants.inputLabelFontStyle],
                fontFamily: `${
                  branding?.[brandingConstants.inputLabelFontFamily]
                }!important`,
                padding: "0px!important",
              },
              "& input::placeholder": {
                fontSize: `${handleFontPreview(
                  branding?.[brandingConstants.inputLabelFontSize],
                  previewAgent
                )}!important`,
                color: branding?.[brandingConstants.inputFieldTextColor],
                fontFamily: `${
                  branding?.[brandingConstants.inputLabelFontFamily]
                }!important`,
                fontWeight: `${
                  branding?.[brandingConstants.inputLabelFontWeight]
                }!important`,
              },
              height: previewAgent ? "60px" : "30px",
              width: previewAgent ? "641px" : "100%",
              "&.Mui-focused": {
                outline: "none!important",
                borderColor: "#5A5A5A!important",
              },
            }}
            id="desc-input"
            placeholder="Your email"
            type="text"
          />
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        {ClickedCatFbsVal?.length > 0 && ClickedCat && (
          <Typography
            sx={{
              color: branding?.[brandingConstants.inputLabelColor],
              fontWeight: branding?.[brandingConstants.inputLabelFontWeight],
              fontStyle: branding?.[brandingConstants.inputLabelFontStyle],
              fontFamily: branding?.[brandingConstants.inputLabelFontFamily],
              fontSize: handleFontPreview(
                branding?.[brandingConstants.inputLabelFontSize],
                previewAgent
              ),
            }}
          >
            {ClickedCat && `${ClickedCat} :`}{" "}
            {product?.feedbackSettings?.stdFeedbackHeading}
          </Typography>
        )}
        <FormGroup
          className="tv-feedback-checkbox"
          sx={{
            marginTop: previewAgent ? "15px" : "10px",
            marginLeft: "2px",
          }}
        >
          {ClickedCatFbsVal?.length > 0 && ClickedCat && (
            <>
              {ClickedCatFbsVal.map((value: string) => {
                return (
                  <FormControlLabel
                    control={
                      <Checkbox
                        icon={
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                          >
                            <CheckBoxOutlineBlankIcon
                              sx={{
                                width: previewAgent
                                  ? "20px!important"
                                  : "15px!important",
                                height: previewAgent
                                  ? "25px!important"
                                  : "15px!important",
                                borderRadius:
                                  technology !== "rokuTv"
                                    ? branding?.[
                                        brandingConstants.inputFieldBorderRadius
                                      ]
                                    : "0px",
                                color:
                                  branding?.[
                                    brandingConstants.inputFieldBorderColor
                                  ],
                              }}
                            />
                          </Box>
                        }
                        checkedIcon={
                          <Box
                            display="flex"
                            justifyContent="center"
                            alignItems="center"
                            sx={{
                              width: previewAgent
                                ? "20px!important"
                                : "15px!important",
                              height: previewAgent
                                ? "20px!important"
                                : "15px!important",
                              borderRadius:
                                technology !== "rokuTv"
                                  ? branding?.[
                                      brandingConstants.inputFieldBorderRadius
                                    ]
                                  : "0px",
                              background:
                                branding?.[brandingConstants.inputFieldBGColor],
                              border: `1px solid ${
                                branding?.[
                                  brandingConstants.inputFieldBorderColor
                                ]
                              }`,
                            }}
                          >
                            <CheckIcon
                              sx={{
                                width: previewAgent
                                  ? "18px!important"
                                  : "10px!important",
                                height: previewAgent
                                  ? "18px!important"
                                  : "10px!important",
                                color:
                                  branding?.[
                                    brandingConstants.inputFieldBorderColor
                                  ],
                              }}
                            />
                          </Box>
                        }
                      />
                    }
                    sx={{
                      "&.MuiFormControlLabel-root .MuiFormControlLabel-label": {
                        fontSize: handleFontPreview(
                          branding?.[brandingConstants.inputLabelFontSize],
                          previewAgent
                        ),
                        fontWeight:
                          branding?.[brandingConstants.inputLabelFontWeight],
                        color: branding?.[brandingConstants.inputLabelColor],
                      },
                    }}
                    label={value}
                  />
                );
              })}
            </>
          )}
        </FormGroup>
      </Grid>

      <Grid item xs={12}>
        <label
          className="overflow-text-2-line"
          style={{
            margin: "15px 0 10px",
            color: branding?.[brandingConstants.inputLabelColor],
            fontSize: handleFontPreview(
              branding?.[brandingConstants.inputLabelFontSize],
              previewAgent
            ),
            fontStyle: branding?.[brandingConstants.inputLabelFontStyle],
            fontFamily: branding?.[brandingConstants.inputLabelFontFamily],
            fontWeight: branding?.[brandingConstants.inputLabelFontWeight],
          }}
        >
          {`${product?.feedbackSettings?.generalCommentsHeading} ${
            product?.feedbackSettings?.reqComments ? "(Required)" : ""
          }`}
        </label>
        <FormControl className="custom-select custom-textarea" fullWidth>
          {/* <textarea
            className="feedback-textarea"
            placeholder="Provide your comment"
            style={{
              color: branding?.[brandingConstants.inputFieldTextColor],
              fontSize: handleFontPreview(
                branding?.[brandingConstants.inputLabelFontSize],
                previewAgent
              ),
              // fontSize: previewAgent ? "18px" : "9px",
              fontStyle: branding?.[brandingConstants.inputLabelFontStyle],
              fontFamily: branding?.[brandingConstants.inputLabelFontFamily],
              fontWeight: branding?.[brandingConstants.inputLabelFontWeight],
              backgroundColor: branding?.[brandingConstants.inputFieldBGColor],
              border:
                "4px solid" +
                branding?.[brandingConstants?.inputFieldBorderColor],
              borderRadius:
                technology === "html5Tv"
                  ? branding?.[brandingConstants.inputFieldBorderRadius]
                  : "0px",
              height: previewAgent ? "150px" : "100px",
              background: "#fff",
              width: previewAgent ? "641px" : "100%",
            }}
          /> */}
          <OutlinedInput
            className="noborder"
            type="textarea"
            id="desc-input"
            multiline
            placeholder={`Provide your comment`}
            maxRows={4}
            sx={{
              // fontSize: handleFontPreview(
              //   branding?.[brandingConstants.inputLabelFontSize],
              //   previewAgent
              // ),
              fontSize: previewAgent ? "18px" : "9px",
              color: branding?.[brandingConstants.inputFieldTextColor],
              background: branding?.[brandingConstants.inputFieldBGColor],
              border:
                "4px solid " +
                branding?.[brandingConstants?.inputFieldBorderColor],
              borderRadius:
                technology === "html5Tv"
                  ? branding?.[brandingConstants.inputFieldBorderRadius]
                  : "0px",
              alignItems: "start",
              padding: "10px",
              "& textarea": {
                fontSize: `${handleFontPreview(
                  branding?.[brandingConstants.inputLabelFontSize],
                  previewAgent
                )}!important`,
                padding: "0px!important",
                fontFamily: `${
                  branding?.[brandingConstants.inputLabelFontFamily]
                }!important`,
                fontWeight: `${
                  branding?.[brandingConstants.inputLabelFontWeight]
                }!important`,
              },
              "& textarea::placeholder": {
                fontSize: `${handleFontPreview(
                  branding?.[brandingConstants.inputLabelFontSize],
                  previewAgent
                )}!important`,
                color: branding?.[brandingConstants.inputFieldTextColor],
                fontFamily: `${
                  branding?.[brandingConstants.inputLabelFontFamily]
                }!important`,
                fontWeight: `${
                  branding?.[brandingConstants.inputLabelFontWeight]
                }!important`,
              },
              "&.Mui-focused": {
                outline: "none!important",
                borderColor: "#5A5A5A!important",
              },
              height: previewAgent ? "150px" : "100px",
              width: previewAgent ? "641px" : "100%",
            }}
          />
        </FormControl>
      </Grid>
      {product?.qrSettings?.addQR && (
        <Grid item xs={12}>
          <label
            className="overflow-text-2-line"
            style={{
              margin: "15px 0 10px",
              color: branding?.[brandingConstants.inputLabelColor],
              fontSize: handleFontPreview(
                branding?.[brandingConstants.inputLabelFontSize],
                previewAgent
              ),
              fontStyle: branding?.[brandingConstants.inputLabelFontStyle],
              fontFamily: branding?.[brandingConstants.inputLabelFontFamily],
              fontWeight: branding?.[brandingConstants.inputLabelFontWeight],
            }}
          >
            Please attach screenshot to help troubleshoot (optional)
          </label>
          {/* <Box
          display="inline-flex"
          justifyContent="center"
          alignItems="center"
          style={{
            color: branding?.[brandingConstants.inputFieldTextColor],
            // fontSize: handleFontPreview(
            //   branding?.[brandingConstants.inputLabelFontSize],
            //   previewAgent
            // ),
            fontStyle: branding?.[brandingConstants.inputLabelFontStyle],
            fontFamily: previewAgent
              ? branding?.[brandingConstants.inputLabelFontFamily]
              : "11px",
            fontWeight: branding?.[brandingConstants.inputLabelFontWeight],
            backgroundColor: branding?.[brandingConstants.inputFieldBGColor],
            border:
              "1px solid" +
              branding?.[brandingConstants?.inputFieldBorderColor],
            borderRadius:
              technology === "html5Tv"
                ? branding?.[brandingConstants.inputFieldBorderRadius]
                : "0px",
            width: previewAgent ? "200px" : "100px",
            height: previewAgent ? "60px" : "30px",
          }}
        >
          <AddIcon
            sx={{
              color: branding?.[brandingConstants.inputFieldTextColor],
              fontSize: previewAgent ? "25px" : "9px",
            }}
          />
        </Box> */}
          <Button
            variant="contained"
            sx={{
              boxShadow: "none",
              backgroundColor:
                branding?.[brandingConstants.secondaryButtonBGColor],
              color: branding?.[brandingConstants?.secondaryButtonTextColor],
              minWidth: previewAgent ? "200px" : "100px",
              minHeight: previewAgent ? "50px" : "20px",
              fontSize: handleFontPreview(
                branding?.[brandingConstants.secondaryButtonFontSize],
                previewAgent
              ),
              fontFamily:
                branding?.[brandingConstants.secondaryButtonFontFamily],
              fontWeight: "700",
              fontStyle: branding?.[brandingConstants.secondaryButtonFontStyle],
              marginRight: previewAgent ? "20px" : "3px",
              border: `1px solid ${
                branding?.[brandingConstants.secondaryButtonBorderColor]
              }`,
              borderRadius:
                technology !== "rokuTv"
                  ? branding?.[brandingConstants.secondaryButtonBorderRadius]
                  : "0px",
              "&:hover": {
                backgroundColor:
                  branding?.[brandingConstants.secondaryButtonBGColor],
                boxShadow: "none",
              },
            }}
          >
            <AddIcon
              sx={{
                "&.MuiSvgIcon-root": {
                  width: previewAgent ? "30px!important" : "20px!important",
                },
              }}
            />
          </Button>
        </Grid>
      )}
    </Grid>
  );
};

export default ThirdPagePreview;
